import axios from 'axios';
import { showTabs, selectTab } from '../common/tab/tabActions';
import consts from '../consts';
import { setErroAPI, setSuccess } from '../common/toast/toast';
import { reset as resetForm, initialize } from 'redux-form';
import DateFormat from '../common/dateFormat/DateFormat';

export function setModoTela(modo, registro = { id_estoque_local: 2 }) {
    return {
        type: 'EMBALAGEM_SAIDA_MODO_TELA',
        payload: {
			modo: modo,
			registro: registro
		}
    };
}

export function setAguardando(aguardando) {
    return {
        type: 'EMBALAGEM_SAIDA_SET_AGUARDANDO',
        payload: aguardando
    };
}

export function setFiltro(filtro) {
    return {
        type: 'EMBALAGEM_SAIDA_FILTRO',
        payload: {
			filtro: filtro
		}
    };
}

export function initForm(registro) {
    return [
        initialize('embalagemSaidaForm', registro)
    ];
}

export function getLista() {
	return (dispatch, getState) => {
		dispatch(setAguardando(true));
    	axios.get(`${consts.API_URL}/embalagemSaida?id_cliente=${getState().auth.usuario.id_cliente || 0}
				&data_inicial=${DateFormat.formatarDataTelaParaSql(getState().embalagemSaida.filtro.data_inicial) == 'Invalid DateTime' ? null : DateFormat.formatarDataTelaParaSql(getState().embalagemSaida.filtro.data_inicial)}
				&data_final=${DateFormat.formatarDataTelaParaSql(getState().embalagemSaida.filtro.data_final) == 'Invalid DateTime' ? null : DateFormat.formatarDataTelaParaSql(getState().embalagemSaida.filtro.data_final)}`)
		.then(resp => {
			dispatch({
		        type: 'EMBALAGEM_SAIDA_LISTADO',
		        payload: resp
		    });
			dispatch(setAguardando(false));
		}).catch(e => {
			setErroAPI(e);
			dispatch(setAguardando(false));
		});
	}
}

export function salvar(registro) {
    return (dispatch, getState) => {
		if (!registro.id) {
	        axios.post(`${consts.API_URL}/embalagemSaida`, {
				...registro,
				id_cliente: getState().auth.usuario.id_cliente,
				id_usuario_alteracao: getState().auth.usuario.id,
				datahora_saida: DateFormat.getDataHoraAtual(),
				quantidade: String(registro.quantidade || '').replace(',', '.'),
				minimo: 0,
				maximo: 0
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		} else {
			axios.put(`${consts.API_URL}/embalagemSaida`, {
				...registro,
				id_usuario_alteracao: getState().auth.usuario.id,
				datahora_saida: DateFormat.formatarDataHoraTelaParaSql(registro.datahora_saida),
				quantidade: String(registro.quantidade || '').replace(',', '.'),
				minimo: 0,
				maximo: 0
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		}
    };
}

export function excluir(registro) {
    return dispatch => {
        axios.delete(`${consts.API_URL}/embalagemSaida?id=${registro.id}`)
		.then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getLista());
			dispatch(setModoTela('lista'));
		}).catch(e => {
			setErroAPI(e);
		});
    };
}

export function getListaFornecedor() {
	return (dispatch, getState) => {
    	axios.get(`${consts.API_URL}/fornecedor/listarSelect?id_cliente=${getState().auth.usuario.id_cliente || 0}`)
		.then(resp => {
			dispatch({
				type: 'EMBALAGEM_SAIDA_FORNECEDOR_SELECT_LISTADO',
		        payload: resp
		    });
		}).catch(e => {
			setErroAPI(e);
		});
	}
}

export function getListaEmbalagem() {
	return (dispatch, getState) => {
    	axios.get(`${consts.API_URL}/embalagem/listarSelect?id_cliente=${getState().auth.usuario.id_cliente || 0}`)
		.then(resp => {
			dispatch({
				type: 'EMBALAGEM_SAIDA_EMBALAGEM_SELECT_LISTADO',
		        payload: resp
		    });
		}).catch(e => {
			setErroAPI(e);
		});
	}
}

export function getListaEstoqueLocal() {
    const request = axios.get(`${consts.API_URL}/estoqueLocal/listarSelect`);
    return {
        type: 'EMBALAGEM_SAIDA_ESTOQUE_LOCAL_SELECT_LISTADO',
        payload: request
    };
}

export function getListaMotivo() {
	return (dispatch, getState) => {
    	axios.get(`${consts.API_URL}/embalagemSaidaMotivo/listarSelect`)
		.then(resp => {
			dispatch({
				type: 'EMBALAGEM_SAIDA_MOTIVO_SELECT_LISTADO',
		        payload: resp
		    });
		}).catch(e => {
			setErroAPI(e);
		});
	}
}
